<template>
  <tbody class="user-list__user__table__tbody">
  <tr v-for="event in events" :key="event.event_id" class="user-list__user__table__event"
      :class="{'user-list__user__table__event--special': event.v_is_special, 'user-list__user__table__event--zeroed': event.zero}">
    <td>{{ event.v_start_and_endtime }} | <span class="d-tag" v-if="event.v_is_special">{{
        event.title
      }}</span><b v-else>{{ event.title }}</b></td>
    <td>{{ event.v_calendar_name }}</td>
    <td><span class="d-tag">{{ event.v_event_type_name }}</span>
    </td>
    <td>
      {{ event.v_substitute_for_name }}
      <span class="d-tag"
            v-if="event.v_substitute_for_employments.length > 0"
            :content='event.v_substitute_for_employments'
            v-tippy="{
                            arrow: true,
                            animateFill: false,
                            animation : 'shift-away',
                            zIndex: '999999992',
                            boundary: 'window',
                            onShow: () => event.v_substitute_for_employments.length > 1
                          }">
                      {{ event.v_substitute_for_employments[0] }}
                      <template v-if="event.v_substitute_for_employments.length > 1">m.fl.</template>
                    </span>
    </td>
    <td class="td-employment">
      <div class="td-employment__value">
        <template v-if="userDay.state === 'draft'">
          <p class="text-explainer" v-if="user.v_user_active_employments.length < 1">Ingen ansættelser</p>
          <select class="no-print" v-else
                  @change="updatePropOnLesson('employment_id', user, userDay, event, $event.target.value)"
                  v-model.number="event.employment_id"
                  :content="event.v_employment_details_tip"
                  v-tippy="{
                    arrow: true,
                    animateFill: false,
                    animation: 'shift-away',
                    zIndex: '999999992',
                    boundary: 'window',
                    onShow: () => !!event.v_employment_details_tip
                  }">
            <option v-for="userEmployment in user.v_user_active_employments" :key="userEmployment.id" :value="Number(userEmployment.id)">
              {{ userEmployment.title }}
            </option>
          </select>
          <span class="only-print" :class="{'italic': event.v_employment_id_title === 'Ingen valgt'}">
            {{ event.v_employment_id_title }}
          </span>
        </template>
        <span v-else
              :class="{'d-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'}"
              :content="event.v_employment_details_tip"
              v-tippy="{
                arrow: true,
                animateFill: false,
                animation: 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => !!event.v_employment_details_tip
              }">{{
            event.v_employment_id_title
          }}
        </span>
        <div
          v-if="event.v_employment_source_tip"
          class="td-employment__help no-print"
          :content="event.v_employment_source_tip"
          v-tippy="{
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          }">
          <span class="icon-question3"></span>
        </div>
      </div>
    </td>
    <td v-if="isSalaryIntegrationActive">
      <select class="do-select"
              v-model.number="event.salary_code_id"
              :disabled="userDay.state !== 'draft'"
              @input="updatePropOnLesson('salary_code_id', user, userDay, event, $event.target.value)">
       <option value=""></option>
        <option v-for="salaryCode in salaryCodes" :key="salaryCode.id" :value="salaryCode.id">
          {{ salaryCode.name }}
        </option>
      </select>
    </td>
    <td v-if="costCenters.length > 0">
      <select
        class="no-print"
        :disabled="userDay.state !== 'draft'"
        v-model="event.afv_omkostningssted"
        @change="updatePropOnLesson('afv_omkostningssted', user, userDay, event, event.afv_omkostningssted)"
      >
        <!-- Mulighed for at nulstille til null -->
        <option :value="null"></option>

        <option
          v-for="costCenter in costCenters"
          :key="costCenter.code"
          :value="costCenter.code"
        >
          {{ costCenter.title }}
        </option>
      </select>
    </td>
    <td>
      {{ event.minutes }} min.
    </td>
    <td class="td-zero-toggle no-print">
      <button
        v-if="userDay.state === 'draft'"
        class="do-zero-bttn"
        :class="{'do-zero-bttn--active': event.zero}"
        @click="updatePropOnLesson('zero', user, userDay, event, !event.zero)"
        :content="event.zero ? 'Gendan linje' : 'Nulstil linje'"
        v-tippy="{
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }">
        <span class="icon-bin" v-if="!event.zero"></span>
        <svg v-else class="do-zero-bttn__undo-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="1 4 1 10 7 10"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
        </svg>
      </button>
    </td>
  </tr>
  </tbody>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    user: {
      type: Object
    },
    userDay: {
      type: Object
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    },
    salaryCodes: {
      type: Array,
      default: () => []
    },
    costCenters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    events () {
      // Add custom props to each event
      return this.userDay.events.map(event => {
        const userEmployments = this.user.v_user_employments // this.userDay.getUserEmployments(this.userDay.user_id)
        return {
          ...event,
          v_is_special: event.event_type.startsWith('_extra_time_'),
          v_start_and_endtime: moment(event.start).format('LT') + ' - ' + moment(event.end).format('LT'),
          v_calendar_name: event.calendars ? this.getCalendarName(event) : '',
          v_substitute_for_employments: event.substitute_for_user_id ? this.getSubstituteForEmployments(event.substitute_for_user_id) : [],
          v_substitute_for_name: event.substitute_for_user_id && this.allUsersInHash[event.substitute_for_user_id] ? this.allUsersInHash[event.substitute_for_user_id]['name'] : '',
          v_event_type_name: this.getExtraEventTitle(event.event_type) || (this.$t('vue2.eventTypes.' + event.event_type) !== 'vue2.eventTypes.' + event.event_type
            ? this.$t('vue2.eventTypes.' + event.event_type)
            : event.event_type),
          v_employment_id_title: event.employment_id ? userEmployments.find(userEmployment => userEmployment.id === event.employment_id) ? userEmployments.find(userEmployment => userEmployment.id === event.employment_id)['title'] : event.employment_id : 'Ingen valgt',
          v_employment_details_tip: this.employmentDetailsTip(event.employment),
          ...this.employmentSourceProps(event)
        }
      })
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    schoolSubstituteRules () {
      const school = this.$store.state.activeSchool
      return school && school.substitute_rules ? school.substitute_rules : {}
    }
  },
  methods: {
    employmentDetailsTip (employment) {
      if (!employment || typeof employment !== 'object') return ''
      const formatDate = date => date ? moment(date).format('DD-MM-YYYY') : ''
      const lines = []
      const heading = [employment.employment_number, employment.source_title].filter(Boolean).join(' - ')
      if (heading) lines.push('<b>' + heading + '</b>')
      if (employment.organisation) lines.push(employment.organisation)
      if (employment.employment_percent != null && employment.employment_percent !== '') {
        lines.push(parseFloat(employment.employment_percent) + '%')
      }
      if (employment.start_date) {
        const hasEndDate = employment.end_date && employment.end_date !== '2099-12-31'
        lines.push(hasEndDate
          ? formatDate(employment.start_date) + ' – ' + formatDate(employment.end_date)
          : 'Fra ' + formatDate(employment.start_date))
      }
      return lines.join('<br>')
    },
    employmentSourceProps (event) {
      if (this.userDay.state !== 'draft' || !event.employment_id) {
        return {
          v_employment_source: null,
          v_employment_source_tip: ''
        }
      }
      if (event.rule_id) {
        return {
          v_employment_source: 'rule',
          v_employment_source_tip: this.ruleTooltip(event.rule_id)
        }
      }
      if (this.eventHasSavedEmployment(event)) {
        return {
          v_employment_source: 'saved',
          v_employment_source_tip: 'Ansættelsen er gemt på dagen og opdateres ikke automatisk, når regler ændres.'
        }
      }
      return {
        v_employment_source: null,
        v_employment_source_tip: ''
      }
    },
    eventHasSavedEmployment (event) {
      const saved = this.userDay && this.userDay.employments
      if (!saved || typeof saved !== 'object') return false
      const eventId = String(event.event_id)
      const val = saved[eventId]
      return val != null && val !== 0 && val !== '0' && val !== ''
    },
    ruleTooltip (ruleId) {
      const rules = this.schoolSubstituteRules.rules || []
      const rule = rules.find(item => String(item.id) === String(ruleId))
      if (!rule) return 'Sat af en regel'
      return this.describeRule(rule)
    },
    describeRule (rule) {
      const selected = this.employmentTitleName(rule.selected_employment_title)
      if (rule.type === 'employment_type') {
        return 'Hvis man er vikar for ' + (rule.substituted_employment_title || '') + ', tæller det som ' + selected + '.'
      }
      if (rule.type === 'subject_type') {
        return 'Hvis briktypen er ' + this.subjectTypeName(rule.subject_type) + ', tæller det som ' + selected + '.'
      }
      if (rule.type === 'subject_title') {
        return 'Hvis brikken hedder “' + (rule.subject_title || '') + '”, tæller det som ' + selected + '.'
      }
      if (rule.type === 'calendar_id') {
        return 'Hvis kalenderen er ' + this.calendarNameById(rule.calendar_id) + ', tæller det som ' + selected + '.'
      }
      return selected || 'Sat af en regel'
    },
    employmentTitleName (title) {
      if (title === '*Stillingen fra lektionen efter*') return 'stillingen fra lektionen efter'
      if (title === '*Stillingen fra lektionen før*') return 'stillingen fra lektionen før'
      return title || ''
    },
    subjectTypeName (subjectType) {
      const extraTimeNames = {
        _extra_time_at_start_of_day_: 'ekstra tid før første lektion',
        _extra_time_between_events_: 'ekstra tid mellem timer',
        _extra_time_if_shorter_than_: 'ekstra tid, når dagen er for kort'
      }
      if (extraTimeNames[subjectType]) return extraTimeNames[subjectType]
      const key = 'vue2.eventTypes.' + subjectType
      const translated = this.$t(key)
      return translated !== key ? translated.toLowerCase() : (subjectType || '')
    },
    calendarNameById (calendarId) {
      const calendars = []
        .concat(this.$store.getters.klassCalendars || [])
        .concat(this.$store.getters.clubCalendars || [])
        .concat(this.$store.getters.otherCalendars || [])
      const calendar = calendars.find(item => String(item.id) === String(calendarId))
      return calendar && calendar.name ? calendar.name : (calendarId || '')
    },
    updatePropOnLesson (propToUpdate, user, userDay, event, val) {
      const obj = {propToUpdate, user, userDay, event, val}
      console.log(propToUpdate, val)
      this.$emit('updatePropOnLesson', obj)
    },
    getCalendarName (event) {
      const calendar = event.calendars ? event.calendars.find(calEvent => calEvent.calendar_id === event.calendar_id) : null
      return calendar ? calendar.name : ''
    },
    getSubstituteForEmployments (substituteForUserId) {
      return this.getUserEmployments(substituteForUserId).map(employment => employment.title)
    },
    getUserEmployments (userId) {
      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : []
    },
    getExtraEventTitle (eventTitle) {
      const obj = {
        _extra_time_at_start_of_day_: 'Ekstra tid',
        _extra_time_if_shorter_than_: 'Ekstra tid',
        _extra_time_between_events_: 'Ekstra tid'
      }
      return obj[eventTitle]
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.user-list__user__table__tbody tr td {
  padding: 0.5rem;
}

.user-list__user__table__tbody {
  border-top: 1px solid #e2e8f0;
}

.user-list__user__table__tbody select {
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border-radius: 4px;
  background-color: #fff;
  border: 0;
  min-width: 160px;
}

.user-list__user__table tbody tr td:last-child {
  text-align: right;
}

.td-employment {
  vertical-align: middle;
}

.td-employment__value {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.td-employment__help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  cursor: help;
  font-size: 13px;
  line-height: 1;
  flex-shrink: 0;
}

.td-employment__help:hover {
  color: #4b5563;
}

.user-list__user__table tbody tr {
  transition: 0.15s;
}

.user-list__user__table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.user-list__user__table tbody tr:hover {
  background-color: aliceblue;
}

.d-tag {
  font-size: .8rem;
  background: #f9fafb;
  padding: 0.25rem 0.4rem;
  color: #4b5563;
  border: 1px solid #ebedee;
  border-radius: 4px;
}

.user-list__user__table__event--special .d-tag {
  background: #fefce8;
  border-color: #f4e6c0;
  color: #854d0f;
}

.user-list__user__table__event--zeroed > td:not(.td-zero-toggle) {
  opacity: 0.4;
  text-decoration: line-through;
}

.td-zero-toggle {
  text-align: center !important;
  width: 40px;
}

.do-zero-bttn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: #9ca3af;
  font-size: 14px;
  line-height: 1;
  transition: 0.15s;
}

.do-zero-bttn:hover {
  color: #ef4444;
  background: #fef2f2;
}

.do-zero-bttn--active {
  color: #222;
}

.do-zero-bttn--active:hover {
  color: #222;
  background: #f3f4f6;
}

.do-zero-bttn__undo-icon {
  width: 12px;
  height: 12px;
  display: block;
}

.td-salary-input-number {
  width: 90px;
}

.do-input {
  background: #fff;
  height: 28px;
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border: 1px solid transparent;
}

@media print {
  .user-list__user__table__tbody tr td {
    font-size: 8px;
  }

  .d-tag {
    font-size: 8px;
  }

  .user-list__user__table__event--special .d-tag {
    background: #f9fafb;
    color: #4b5563;
    border: 1px solid #ebedee;
  }
}
</style>



// WEBPACK FOOTER //
// SalarySubsPerfUserDay.vue?67f4195d